import BigNumber from 'bignumber.js'
import erc20ABI from 'config/abi/erc20.json'
import xpMerchantABI from 'config/abi/xpMerchant.json'
import multicall from 'utils/multicall'
import { getAddress, getMasterGamerAddress, getXpMerchantAddress, getXpAddress } from 'utils/addressHelpers'
import { getXpContract } from 'utils/contractHelpers'


export const fetchPublicXpMerchant = async () => {
  const xpMerchantAddress = getXpMerchantAddress()
  const xpAddress = getXpAddress()
  const xpContract = getXpContract();

  // const callXpBalance = {
  //   address: xpAddress,
  //   name: 'balanceOf',
  //   params: [xpMerchantAddress]
  // }

  // const calls = [
  //   callXpBalance
  // ]

  // const rawLockedXpMerchantAmounts = await multicall<BigNumber[]>(xpMerchantABI, calls)

  // const parsedAmounts = rawLockedXpMerchantAmounts.map((xpMerchantBalance) => {
  //   return new BigNumber(xpMerchantBalance).toJSON()
  // })

  const balance = await xpContract.balanceOf(xpMerchantAddress);

  return {
    xpBalance: balance.toString()
  }
}
